export default __webpack_public_path__ + "static/media/paw-print.e984451b.svg";